import { Info } from '../../../Applications/Info';
import { HookCheckboxGroup } from '../../HookForm/Form/CheckBoxGroup';
import { HookCheckbox } from '../../HookForm/Form/Checkbox';
import { HookInput } from '../../HookForm/Form/Input';
import HookMaskedInput from '../../HookForm/Form/MaskedInput';
import { HookRadioGroup } from '../../HookForm/Form/RadioGroup';
import { HookSelect } from '../../HookForm/Form/Select';
import { HookTextarea } from '../../HookForm/Form/TextArea';
import { JsonHookFileInput } from '../JsonHookFileInput';
import type { InputMap } from './types';

export const inputMap: InputMap = {
  input: {
    Component: HookInput,
    defaultProps: {},
  },
  select: {
    Component: HookSelect,
    defaultProps: {},
  },
  date: {
    Component: HookInput,
    defaultProps: {
      type: 'date',
    },
  },
  radio: {
    Component: HookInput,
    defaultProps: {
      type: 'radio',
    },
  },
  checkbox: {
    Component: HookCheckbox,
    defaultProps: {},
  },
  file: {
    Component: JsonHookFileInput,
    defaultProps: {},
  },
  'checkbox-group': {
    Component: HookCheckboxGroup,
    defaultProps: {},
  },
  'radio-group': {
    Component: HookRadioGroup,
    defaultProps: {},
  },
  textarea: {
    Component: HookTextarea,
    defaultProps: {},
  },
  masked: {
    Component: HookMaskedInput,
    defaultProps: {},
  },
  info: {
    Component: Info,
    defaultProps: {},
  },
  'info-with-inputs': {
    Component: Info,
    defaultProps: {},
  },
  empty: {
    Component: undefined,
    defaultProps: {},
  },
};
